var _style, _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "inicio_nombre_apellido",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.8 24.7",
    style: {
      enableBackground: "new 0 0 18.8 24.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000047771630128936865590000015290600128984891798_);}\n\t.st1{fill:#3E1293;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 18.8,
    height: 24.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183222673883153780840000012823367237855274375_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    style: {
      clipPath: "url(#SVGID_00000183222673883153780840000012823367237855274375_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    className: "st1",
    d: "M9.4,15.3v2.3c-3.9,0-7,3.2-7,7H0C0,19.5,4.2,15.3,9.4,15.3L9.4,15.3 M9.4,15.3 c5.2,0,9.4,4.2,9.4,9.4l0,0h-2.3c0-3.9-3.2-7-7-7V15.3z M9.4,14.1c-3.9,0-7-3.2-7-7s3.2-7,7-7s7,3.2,7,7l0,0 C16.4,10.9,13.3,14.1,9.4,14.1z M9.4,11.7c2.6,0,4.7-2.1,4.7-4.7S12,2.3,9.4,2.3S4.7,4.4,4.7,7l0,0C4.7,9.6,6.8,11.7,9.4,11.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.f80d9aae903daa03abd602f64d8cb22f.svg";
export { ForwardRef as ReactComponent };